import { render, staticRenderFns } from "./MuxAdmin.vue?vue&type=template&id=17407325&scoped=true"
import script from "./MuxAdmin.vue?vue&type=script&lang=js"
export * from "./MuxAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17407325",
  null
  
)

export default component.exports